export default class dataList {
    static pages() {
        return [
            { name: 'home', imageAlt : 'Background', images: [require('../assets/img/home/bg.png')] },     
            { name:'server-error', imageAlt : 'Background', images: [require('../assets/img/evening-bg.png')]},  
            { name:'not-found', imageAlt : 'Background', images: [require('../assets/img/evening-bg.png')]},  
            { name:'different-delivery', imageAlt : 'Background', images: [require('../assets/img/different-delivery/midday-bg.png')]},  
            { name: 'dosing', imageAlt : 'Background', images: [require('../assets/img/dosing/night-bg.png'), require('../assets/img/dosing/night-bg-sm.png')]},  
            { name:'thank-you', imageAlt : 'Background', images: [require('../assets/img/thank-you/bg.png')]},  
            { name:'safety', imageAlt : 'Background', images: [require('../assets/img/evening-bg.png')]},  
            { name:'support', imageAlt : 'Background', images: [require('../assets/img/videos/bg.png')]},  
            //{ name:'support', images: [require('../assets/img/evening-bg.png')]},  
            { name:'request-info', imageAlt : 'Background', images: [require('../assets/img/request-info/midday-bg.png')]},  
            { name:'efficacy', imageAlt : 'Background', images: [require('../assets/img/evening-bg.png')]},  
            { name:'videos', imageAlt : 'Background', images: [require('../assets/img/videos/bg.png')]},  
        ]
    }

    static homePage() {
        return {
            novels: [
                {
                    text: 'An ADHD stimulant dosed in the evening? ',
                    descr: [ 'The unique delayed-release and',
                        'extended-release DELEXIS<sup class="firm">®</sup> drug delivery ',
                        'technology makes it possible.'
                    ],
                    btn: 'See how it works >',
                    image: require('../assets/img/card/moon.png'),
                    path: '/different-delivery',
                    dataCategory: 'Home',
                    dataLabel: 'See how it works'
                },
                {
                    text: 'Proven efficacy with JORNAY PM',
                    descr: [ 'Now you can help improve ADHD symptoms', 
                        'when patients wake up, throughout the day,', 
                        'and evening.'
                    ],
                    btn: 'See the results >',
                    image: require('../assets/img/card/list.png'),
                    path: '/efficacy',
                    dataCategory: 'channel-box',
                    dataLabel: 'See the results'
                },
            ],
            more: [
                {
                    text: '<span class="d-block">The 1st and only ADHD stimulant</span><span class="d-block">dosed in the evening</span>',
                    btn: 'Learn how it’s dosed >',
                    image: require('../assets/img/card/moon.png'),
                    path: '/dosing',
                    dataCategory: 'channel-box',
                    dataLabel: 'Learn how it’s dosed'
                },
                {
                    isSeparator: true
                },
                {
                    text: '<span class="d-block">Help patients start</span><span class="d-block">JORNAY PM and save</span>',
                    btn: 'Learn about savings >',
                    image: require('../assets/img/card/pig.png'),
                    path: '/savings-and-support',
                    dataCategory: 'channel-box',
                    dataLabel: 'Learn about savings'
                },
            ]
        }
    }

    static differentDeliveryPage() {
        return {
            novel: {
                text: 'Novel drug delivery system limits release until early morning and lasts all day',
                descr: ['The DELEXIS<sup>®</sup> drug delivery formulation incorporates advanced microbead technology composed of 2 functional film coatings surrounding a methylphenidate core.'],
                image: require('../assets/img/card/crops.png'),
            },            
            cards: [
                {
                    text: 'Proven efficacy when patients wake up, throughout the day, and evening',
                    btn: 'See the results >',
                    image: require('../assets/img/card/list.png'),
                    path: '/efficacy',
                    dataCategory: 'channel-box',
                    dataLabel: 'See the results'
                },
                {
                    isSeparator: true
                },
                {
                    text: '<span class="d-block">The 1st and only<span><span class="d-block">ADHD stimulant</span><span class="d-block">dosed in the evening</span>',
                    btn: 'Find out how it’s dosed >',
                    image: require('../assets/img/card/moon.png'),
                    path: '/dosing',
                    dataCategory: 'channel-box',
                    dataLabel: 'Find out how it’s dosed'
                },
                {
                    isSeparator: true
                },
                {
                    text: 'Help patients start JORNAY PM and save',
                    btn: 'Learn about savings >',
                    image: require('../assets/img/card/pig.png'),
                    path: '/savings-and-support',
                    dataCategory: 'channel-box',
                    dataLabel: 'Learn about savings'
                },
            ],
            widgetList: [
                'Absorption peaked at approximately 14 hours after dosing',
                'The peak was followed by a gradual decline that lasted throughout the day'
            ]
        }
    }

    static dosingPage() {
        return {
            cards: [
                {
                    text: 'Proven efficacy when patients wake up, throughout the day, and evening',
                    btn: 'See the results >',
                    image: require('../assets/img/card/list.png'),
                    path: '/efficacy',
                    dataCategory: 'channel-box',
                    dataLabel: 'See the results'
                },
                {
                    isSeparator: true
                },
                {
                    text: 'Help patients start JORNAY PM and save',
                    textBottom: 'Help patients start JORNAY PM and save',
                    btn: 'Learn about savings >',
                    image: require('../assets/img/card/pig.png'),
                    path: '/savings-and-support',
                    dataCategory: 'channel-box',
                    dataLabel: 'Learn about savings'

                },
                {
                    isSeparator: true
                },
                {
                    text: 'Request more information about JORNAY PM',
                    btn: 'Request information >',
                    image: require('../assets/img/card/question.png'),
                    path: '/request-info',
                    dataCategory: 'channel-box',
                    dataLabel: 'Request information'
                },
            ],
            dosingCards: [
                {
                    text: 'Starting and titrating<sup>1</sup>',
                    list: ['JORNAY PM is a capsule taken orally, once daily in the evening',
                        'The recommended starting dose for patients 6 years and older is 20 mg once daily in the evening<sup>*</sup>',
                        'Consider whether titration to a higher dose is necessary to achieve continued efficacy '+ 
                        'through the evening. JORNAY PM can be titrated weekly in increments of 20 mg per '  +
                        'day up to maximum daily dose of 100 mg'
                    ],
                    image: require('../assets/img/card/dosing.png'),
                },
                {
                    text: 'Switching from another methylphenidate',
                    list: ['For patients switching from another methylphenidate, discontinue treatment and use ' +
                        'the titration schedule described above',
                        'The relative bioavailability of JORNAY PM (given once a day) compared to the same ' +
                        'daily dose of a methylphenidate immediate-release oral product (given 3 times a day) ' +
                        'in adults is approximately 74%',
                        'Do not substitute for other methylphenidate products on a milligram-per-milligram basis'
                    ],
                    image: require('../assets/img/card/arrows.png'),
                },
                {
                    text: 'Optimizing dosing time',
                    list: ['Dosing time can be optimized to your patients’ needs',
                        'Initiate dosing at 8 <sub>PM</sub><sup>*</sup>',
                        'Adjust the timing of administration between 6:30 <sub>PM</sub> and 9:30 <sub>PM</sub> to optimize efficacy ' +
                        'and tolerability the next morning and throughout the day. Then maintain a consistent ' +
                        'dosing time',
                        'If patients miss their dose at their scheduled time, they should take it as soon as they ' +
                        'remember that same evening. If they only remember the missed dose the next morning, ' +
                        'they should skip the missed dose and resume their normal schedule in the evening'
                    ],
                    cardClass: 'optimizing-time',
                    image: require('../assets/img/card/clock.png'),
                },
                {
                    text: 'Administration options',
                    list: ['Advise patients to take JORNAY PM consistently, with or without food',
                        'May be taken whole, or the capsule may be opened, and the entire contents sprinkled ' +
                        'onto applesauce (to be consumed immediately and entirely without chewing)',
                        'Absorption not dependent on any single factor such as a pH trigger or normal ' +
                        'variations in gastrointestinal (GI) transit'
                    ],
                    image: require('../assets/img/card/capsule.png'),
                }  
            ],
            dosing: [
                {
                    img: require("../assets/img/dosing/1.png"),
                    text: '20 mg',
                    percents: 1.7,
                    percentsTitle: '1.7% of patients optimized on 20 mg at the end of the dose-optimization phase of Study 1',
                    dosingTitle: 'JORNAY PM 20 mg capsule',
                    type: 'capsule'
                },
                {
                    img: require("../assets/img/dosing/3.png"),
                    text: '40 mg',
                    percents: 20.5,
                    type: 'capsule',
                    percentsTitle: '20.5% of patients optimized on 40 mg at the end of the dose-optimization phase of Study 1',
                    dosingTitle: 'JORNAY PM 40 mg capsule',
                },
                {
                    img: require("../assets/img/dosing/4.png"),
                    text: '60 mg',
                    percents: 34.2,
                    type: 'capsule',
                    percentsTitle: '34.2% of patients optimized on 60 mg at the end of the dose-optimization phase of Study 1',
                    dosingTitle: 'JORNAY PM 60 mg capsule',

                },
                {                    
                    type: 'break'
                },
                {
                    img: require("../assets/img/dosing/5.png"),
                    text: '80 mg',
                    percents: 32.5,
                    type: 'capsule',
                    percentsTitle: '32.5% of patients optimized on 80 mg at the end of the dose-optimization phase of Study 1',
                    dosingTitle: 'JORNAY PM 80 mg capsule',

                },
                {
                    img: require("../assets/img/dosing/6.png"),
                    text: '100 mg',
                    percents: 11.1,
                    type: 'capsule',
                    percentsTitle: '11.1% of patients optimized on 100 mg at the end of the dose-optimization phase of Study 1',
                    dosingTitle: 'JORNAY PM 100 mg capsule',

                }
            ]
        }
    }

    static efficacyPage() {
        return {
            cards: [
                {
                    text: 'Awakening and before school',
                    list: [
                        'Study 1 PREMB-R AM  <span class="note">(<i>p</i><0.001 vs placebo)</span>',
                        'Study 2 BSFQ  <span class="note">(<i>p</i><0.001 vs placebo)</span>'
                    ],
                    image: require('../assets/img/card/sunrise.png'),
                },
                {
                    text: 'At school and throughout the day',
                    list: [
                        'Study 1 SKAMP  <span class="note">(<i>p</i><0.001 vs placebo)</span>',
                        'Study 2 ADHD-RS-IV  <span class="note">(<i>p</i>=0.002 vs placebo)</span>'
                    ],
                    image: require('../assets/img/card/sun.png'),
                },
                {
                    text: 'After school until bedtime',
                    list: [
                        'Study 1 PREMB-R PM <span class="note">(<i>p</i>=0.003 vs placebo)</span>',
                        'Study 2 PREMB-R PM  <span class="note">(<i>p</i>=0.002 vs placebo)</span>'
                    ],
                    image: require('../assets/img/card/moon.png'),
                },
            ],
            studyCards: [
                {
                    text: 'Daytime results: primary endpoints using standard ADHD assessments',
                    image: require('../assets/img/card/sun.png'),
                    id: 'daytimeresults',
                    studies: [{
                        suptitle: 'Study 1: SKAMP combined score from 8 <sub>AM</sub> to 8 <sub>PM<sup>2</sup></sub>',
                        subtitle: 'SKAMP: Measures impairment of behaviors in a classroom setting during the school day',
                        chartTitle: 'Classroom study'
                    },
                    {
                        suptitle: 'Study 2: ADHD-RS-IV total score after 3 weeks of treatment<sup>1</sup>',
                        subtitle: 'ADHD-RS-IV: Measures severity of ADHD symptoms at home or school',
                        chartTitle: 'Naturalistic study'
                    }],
                },
                {
                    text: 'Early morning results: key secondary endpoints using novel, validated ADHD assessments',
                    image: require('../assets/img/card/sunrise.png'),                    
                    id: 'earlymorningresults',
                    studies: [{
                        suptitle: 'Study 1: PREMB-R AM scores in the early morning<sup>2</sup>',
                        subtitle: 'PREMB-R AM: Assesses difficulties at home with before-school activities and behaviors during the early morning'
                    },
                    {
                        suptitle: 'Study 2: BSFQ scores after 3 weeks of treatment from 6 <sub>AM</sub> to 9 <sub>AM<sup>1</sup></sub>',
                        subtitle: 'BSFQ: Measures difficulty with early morning activities and behaviors from awakening to leaving home for school'
                    }]
                },
                {
                    text: 'Afternoon/evening results: additional secondary endpoints using novel, validated ADHD assessments',
                    image: require('../assets/img/card/moon.png'),
                    id: 'afternooneveningresults',
                    studies: [{
                        suptitle: '<span class="d-block">Study 1: PREMB-R PM scores in the late afternoon/early evening<sup>2</sup></span>'
                        + '<span class="d-block">PREMB-R PM endpoints were not adjusted for multiplicity</span>',
                    },
                    {
                        suptitle: '<span class="d-block">Study 2: PREMB-R PM scores in the early evening<sup>1,3</sup></span>' +
                        '<span class="d-block">PREMB-R PM endpoints were not adjusted for multiplicity</span>',
                    }]               
                }
            ],
            moreCards: [
                {
                    text: 'Safety profile generally consistent with methylphenidate products',
                    btn: 'See the results >',
                    image: require('../assets/img/card/list.png'),
                    path: '/safety',
                    dataCategory: 'channel-box',
                    dataLabel: 'See the results'
                },
                {
                    isSeparator: true,
                },
                {
                    text: 'Help patients start JORNAY PM and save',
                    textBottom: 'Help patients start JORNAY PM and save',
                    btn: 'Learn about savings >',
                    image: require('../assets/img/card/pig.png'),
                    path: '/savings-and-support',
                    dataCategory: 'channel-box',
                    dataLabel: 'Learn about savings'

                },
                {
                    isSeparator: true,
                },
                {
                    text: 'Request more information about JORNAY PM',
                    btn: 'Request information >',
                    image: require('../assets/img/card/question.png'),
                    path: '/request-info',
                    dataCategory: 'channel-box',
                    dataLabel: 'Request information'
                },
            ]
        }
    }

    static safetyPage() {
        return {
            studies: [
                {
                    block: ['Adverse reactions',
                        'reported in',
                        '&gt;5% of children',
                        'aged 6–12 years old'],
                    title: 'Study 1',
                    descr: 'In the open-label JORNAY PM treatment phase of Study 1, adverse reactions included:',
                    columns: [['Any insomnia',
                            'Decreased appetite',
                            'Affect lability',
                            'Headache',
                            '<span>Upper respiratory </span></span>tract infection</span>'],
                             ['Upper abdominal pain',
                        'Nausea or vomiting',
                        '<span>Increased diastolic </span><span>blood pressure<span>',
                        'Tachycardia',
                        'Irritability']] 
                },
                {
                    block: ['Most common',
                    'adverse reactions',
                    'reported in ≥5%',
                    'of children aged',
                    '6–12 years old'],
                    title: 'Study 2',
                    descr: 'In the 3-week, double-blind, placebo-controlled Study 2, the most common adverse reactions included:',
                    columns: [['Any insomnia',
                        'Decreased appetite',
                        'Headache',
                        'Vomiting'],
                        ['Nausea',
                        'Psychomotor hyperactivity',
                        'Affect lability or mood swings']]
                }

            ],
            cards: [
                {
                    text: 'Proven efficacy when patients wake up, throughout the day, and evening',
                    btn: 'See the results >',
                    image: require('../assets/img/card/list.png'),
                    path: '/efficacy',
                    dataCategory: 'channel-box',
                    dataLabel: 'See the results'
                },
                {
                    text: 'The 1st and only ADHD stimulant dosed in the evening',
                    btn: 'Find out how it’s dosed >',
                    image: require('../assets/img/card/moon.png'),
                    path: '/dosing',
                    dataCategory: 'channel-box',
                    dataLabel: 'Find out how it’s dosed'
                },
                {
                    text: 'Request more information about <span class="nowrap">JORNAY PM</span>',
                    btn: 'Request information >',
                    image: require('../assets/img/card/question.png'),
                    path: '/request-info',
                    dataCategory: 'channel-box',
                    dataLabel: 'Request information'
                },
            ]
        }
    }

    static supportPage() {
        return {
            cards: [
                {
                    text: 'Your commercially insured patients pay $0 for the first prescription.',
                    descr: ['For refills, your patients will pay no more than $25 if their insurance covers JORNAY PM, and no more than $75 if their insurance does not cover JORNAY PM.'],
                    //image: require('../assets/img/card/pig.png'),                    
                },
                {
                    text: 'Proven efficacy when patients wake up, throughout the day, and evening',
                    path: '/efficacy',
                    btn: 'See the results >',
                    image: require('../assets/img/card/list.png'),
                    dataCategory: 'channel-box',
                    dataLabel: 'See the results'
                },
                {
                    text: 'The 1st and only ADHD stimulant dosed in the evening',
                    btn: 'Find out how it’s dosed >',
                    image: require('../assets/img/card/moon.png'),
                    path: '/dosing',
                    dataCategory: 'channel-box',
                    dataLabel: 'Find out how it’s dosed'
                },
                {
                    text: 'Novel technology delivers drug in the early morning and lasts all day',
                    btn: 'Find out how it works >',
                    image: require('../assets/img/card/crops.png'),
                    path: '/different-delivery',
                    dataCategory: 'channel-box',
                    dataLabel: 'Find out how it works'
                },
            ]
        }
    }

    static thankYouPage() {
        return {
            cards: [
                {
                    text: 'Long, smooth pharmacokinetic profile',
                    btn: 'Discover smooth',
                    image: require('../assets/img/card/jpm_clock-icon@2x.png'),
                    path: '/#pk-profile',
                    dataCategory: 'channel-box',
                    dataLabel: 'Discover smooth',
                    alt: 'Clock icon'
                },
                {
                    text: 'The first and only ADHD stimulant dosed in the evening',
                    btn: 'Discover the dosing',
                    image: require('../assets/img/card/jpm_moon-icon@2x.png'),
                    path: '/#dosingtitration',
                    dataCategory: 'channel-box',
                    dataLabel: 'Discover the dosing',
                    alt: 'Moon icon'
                }
            ]
        }
    }
}